import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {animate, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'tcore-button-add-row',
  templateUrl: './button-add-row.component.html',
  styleUrls: ['./button-add-row.component.css'],
  animations: [
    trigger('controlsInOut', [
      transition('void => *', [
        style({
          opacity: '0',
          transform: 'translateY(-100%)',
          height: '0',
          padding: '0'
        }),
        animate(300)
      ]),
      transition('* => void', [
        style({
          opacity: '1',
          transform: 'translateY(0)',
          height: '*',
          padding: '1rem'
        }),
        animate(300,
          style({
            opacity: '0',
            transform: 'translateY(-100%)',
            height: '0',
            padding: '0'
          })
        )
      ])
    ])
  ]
})
export class ButtonAddRowComponent implements OnInit {
  @Input() titleKey: string;
  @Input() customClass: string;

  @Output() confirm = new EventEmitter();
  @Output() cancel = new EventEmitter();

  controlsActive: boolean;

  @Input() confirmDeactivate = false;

  constructor() { }

  ngOnInit() {
    this.controlsActive = false;
  }

  doAction() {
    if (!this.confirmDeactivate) {
      this.controlsActive = false;
    }
    this.confirm.emit({callback: (doThat) => {
      if (doThat) {
        this.controlsActive = false;
      }
    }});
  }

  cancelAction() {
    this.controlsActive = false;
    this.cancel.emit();
  }

  showControls() {
    this.controlsActive = true;
  }
}
